/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HireJobCreditsListParams,
  JobCredit,
  JobCreditCreateRequest,
  JobCreditCreateResponse,
  JobCreditRequest,
  JobCreditStats,
  JobCreditsListParams,
  PaginatedJobCreditList,
  PatchedJobCreditRequest
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getHireJobCreditsListUrl = (params?: HireJobCreditsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/job-credits/?${stringifiedParams}` : `/api/hire/job-credits/`
}

/**
 * ViewSet for JobCredit management - admin only.
 */
export const hireJobCreditsList = async (params?: HireJobCreditsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedJobCreditList> => {

  return customFetch<PaginatedJobCreditList>(getHireJobCreditsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireJobCreditsListInfiniteQueryKey = (params?: HireJobCreditsListParams,) => {
    return [
    'infinite', `/api/hire/job-credits/`, ...(params ? [params] : [])
    ] as const;
    }

export const getHireJobCreditsListQueryKey = (params?: HireJobCreditsListParams,) => {
    return [
    `/api/hire/job-credits/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireJobCreditsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hireJobCreditsList>>, HireJobCreditsListParams['page']>, TError = void>(params?: HireJobCreditsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobCreditsList>>, TError, TData, QueryKey, HireJobCreditsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobCreditsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobCreditsList>>, QueryKey, HireJobCreditsListParams['page']> = ({ signal, pageParam }) => hireJobCreditsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobCreditsList>>, TError, TData, QueryKey, HireJobCreditsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobCreditsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobCreditsList>>>
export type HireJobCreditsListInfiniteQueryError = void


export function useHireJobCreditsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireJobCreditsList>>, HireJobCreditsListParams['page']>, TError = void>(
 params: undefined |  HireJobCreditsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobCreditsList>>, TError, TData, QueryKey, HireJobCreditsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobCreditsList>>,
          TError,
          Awaited<ReturnType<typeof hireJobCreditsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobCreditsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireJobCreditsList>>, HireJobCreditsListParams['page']>, TError = void>(
 params?: HireJobCreditsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobCreditsList>>, TError, TData, QueryKey, HireJobCreditsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobCreditsList>>,
          TError,
          Awaited<ReturnType<typeof hireJobCreditsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobCreditsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireJobCreditsList>>, HireJobCreditsListParams['page']>, TError = void>(
 params?: HireJobCreditsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobCreditsList>>, TError, TData, QueryKey, HireJobCreditsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobCreditsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireJobCreditsList>>, HireJobCreditsListParams['page']>, TError = void>(
 params?: HireJobCreditsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobCreditsList>>, TError, TData, QueryKey, HireJobCreditsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobCreditsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobCreditsListQueryOptions = <TData = Awaited<ReturnType<typeof hireJobCreditsList>>, TError = void>(params?: HireJobCreditsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobCreditsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobCreditsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobCreditsList>>> = ({ signal }) => hireJobCreditsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireJobCreditsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobCreditsListQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobCreditsList>>>
export type HireJobCreditsListQueryError = void


export function useHireJobCreditsList<TData = Awaited<ReturnType<typeof hireJobCreditsList>>, TError = void>(
 params: undefined |  HireJobCreditsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobCreditsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobCreditsList>>,
          TError,
          Awaited<ReturnType<typeof hireJobCreditsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobCreditsList<TData = Awaited<ReturnType<typeof hireJobCreditsList>>, TError = void>(
 params?: HireJobCreditsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobCreditsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobCreditsList>>,
          TError,
          Awaited<ReturnType<typeof hireJobCreditsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobCreditsList<TData = Awaited<ReturnType<typeof hireJobCreditsList>>, TError = void>(
 params?: HireJobCreditsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobCreditsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobCreditsList<TData = Awaited<ReturnType<typeof hireJobCreditsList>>, TError = void>(
 params?: HireJobCreditsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobCreditsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobCreditsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobCreditsCreateUrl = () => {




  return `/api/hire/job-credits/`
}

/**
 * ViewSet for JobCredit management - admin only.
 */
export const hireJobCreditsCreate = async (jobCreditCreateRequest?: JobCreditCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<JobCreditCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<JobCreditCreateResponse>(getHireJobCreditsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(jobCreditCreateRequest)
  }
);}





export const getHireJobCreditsCreateMutationKey = () => ['hireJobCreditsCreate'] as const;

export const getHireJobCreditsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobCreditsCreate>>, TError,HireJobCreditsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireJobCreditsCreate>>, TError,HireJobCreditsCreateMutationVariables, TContext> => {

const mutationKey = getHireJobCreditsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireJobCreditsCreate>>, HireJobCreditsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  hireJobCreditsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireJobCreditsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireJobCreditsCreate>>>
    export type HireJobCreditsCreateMutationBody = JobCreditCreateRequest | undefined
    export type HireJobCreditsCreateMutationError = void
    export type HireJobCreditsCreateMutationVariables = {data?: JobCreditCreateRequest}

    export const useHireJobCreditsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobCreditsCreate>>, TError,HireJobCreditsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireJobCreditsCreate>>,
        TError,
        HireJobCreditsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireJobCreditsCreateMutationOptions(options), queryClient);
    }
    export const getHireJobCreditsRetrieveUrl = (id: number,) => {




  return `/api/hire/job-credits/${id}/`
}

/**
 * ViewSet for JobCredit management - admin only.
 */
export const hireJobCreditsRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<JobCredit> => {

  return customFetch<JobCredit>(getHireJobCreditsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireJobCreditsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/hire/job-credits/${id}/`
    ] as const;
    }


export const getHireJobCreditsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireJobCreditsRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobCreditsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobCreditsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobCreditsRetrieve>>> = ({ signal }) => hireJobCreditsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireJobCreditsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobCreditsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobCreditsRetrieve>>>
export type HireJobCreditsRetrieveQueryError = void


export function useHireJobCreditsRetrieve<TData = Awaited<ReturnType<typeof hireJobCreditsRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobCreditsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobCreditsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobCreditsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobCreditsRetrieve<TData = Awaited<ReturnType<typeof hireJobCreditsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobCreditsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobCreditsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobCreditsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobCreditsRetrieve<TData = Awaited<ReturnType<typeof hireJobCreditsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobCreditsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobCreditsRetrieve<TData = Awaited<ReturnType<typeof hireJobCreditsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobCreditsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobCreditsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobCreditsUpdateUrl = (id: number,) => {




  return `/api/hire/job-credits/${id}/`
}

/**
 * ViewSet for JobCredit management - admin only.
 */
export const hireJobCreditsUpdate = async (id: number,
    jobCreditRequest?: JobCreditRequest, options?: Parameters<typeof customFetch>[1]): Promise<JobCredit> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<JobCredit>(getHireJobCreditsUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(jobCreditRequest)
  }
);}





export const getHireJobCreditsUpdateMutationKey = () => ['hireJobCreditsUpdate'] as const;

export const getHireJobCreditsUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobCreditsUpdate>>, TError,HireJobCreditsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireJobCreditsUpdate>>, TError,HireJobCreditsUpdateMutationVariables, TContext> => {

const mutationKey = getHireJobCreditsUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireJobCreditsUpdate>>, HireJobCreditsUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  hireJobCreditsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireJobCreditsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof hireJobCreditsUpdate>>>
    export type HireJobCreditsUpdateMutationBody = JobCreditRequest | undefined
    export type HireJobCreditsUpdateMutationError = void
    export type HireJobCreditsUpdateMutationVariables = {id: number;data?: JobCreditRequest}

    export const useHireJobCreditsUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobCreditsUpdate>>, TError,HireJobCreditsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireJobCreditsUpdate>>,
        TError,
        HireJobCreditsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getHireJobCreditsUpdateMutationOptions(options), queryClient);
    }
    export const getHireJobCreditsPartialUpdateUrl = (id: number,) => {




  return `/api/hire/job-credits/${id}/`
}

/**
 * ViewSet for JobCredit management - admin only.
 */
export const hireJobCreditsPartialUpdate = async (id: number,
    patchedJobCreditRequest?: PatchedJobCreditRequest, options?: Parameters<typeof customFetch>[1]): Promise<JobCredit> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<JobCredit>(getHireJobCreditsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedJobCreditRequest)
  }
);}





export const getHireJobCreditsPartialUpdateMutationKey = () => ['hireJobCreditsPartialUpdate'] as const;

export const getHireJobCreditsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobCreditsPartialUpdate>>, TError,HireJobCreditsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireJobCreditsPartialUpdate>>, TError,HireJobCreditsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getHireJobCreditsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireJobCreditsPartialUpdate>>, HireJobCreditsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  hireJobCreditsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireJobCreditsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof hireJobCreditsPartialUpdate>>>
    export type HireJobCreditsPartialUpdateMutationBody = PatchedJobCreditRequest | undefined
    export type HireJobCreditsPartialUpdateMutationError = void
    export type HireJobCreditsPartialUpdateMutationVariables = {id: number;data?: PatchedJobCreditRequest}

    export const useHireJobCreditsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobCreditsPartialUpdate>>, TError,HireJobCreditsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireJobCreditsPartialUpdate>>,
        TError,
        HireJobCreditsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getHireJobCreditsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getHireJobCreditsStatsRetrieveUrl = () => {




  return `/api/hire/job-credits/stats/`
}

/**
 * Get credit statistics for the active location (X-Gigpro-Location-Id header).
 *
 * Per WORK-5057, stats follow the active location, not the org. The header is
 * required — the FE interceptor sends it on every request. The caller's
 * permission to read this location is verified before any DB aggregation runs.
 *
 * - available: Unused credits (used_ts is null)
 * - free_available: Unused free credits (used_ts is null and fee_cents=0)
 * - pending: Job offers with status=SENT at this location
 * - used: Credits with used_ts set and linked to ACCEPTED job offers
 */
export const hireJobCreditsStatsRetrieve = async ( options?: Parameters<typeof customFetch>[1]): Promise<JobCreditStats> => {

  return customFetch<JobCreditStats>(getHireJobCreditsStatsRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireJobCreditsStatsRetrieveQueryKey = () => {
    return [
    `/api/hire/job-credits/stats/`
    ] as const;
    }


export const getHireJobCreditsStatsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireJobCreditsStatsRetrieve>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobCreditsStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobCreditsStatsRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobCreditsStatsRetrieve>>> = ({ signal }) => hireJobCreditsStatsRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireJobCreditsStatsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobCreditsStatsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobCreditsStatsRetrieve>>>
export type HireJobCreditsStatsRetrieveQueryError = void


export function useHireJobCreditsStatsRetrieve<TData = Awaited<ReturnType<typeof hireJobCreditsStatsRetrieve>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobCreditsStatsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobCreditsStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobCreditsStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobCreditsStatsRetrieve<TData = Awaited<ReturnType<typeof hireJobCreditsStatsRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobCreditsStatsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobCreditsStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobCreditsStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobCreditsStatsRetrieve<TData = Awaited<ReturnType<typeof hireJobCreditsStatsRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobCreditsStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobCreditsStatsRetrieve<TData = Awaited<ReturnType<typeof hireJobCreditsStatsRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobCreditsStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobCreditsStatsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getJobCreditsListUrl = (params?: JobCreditsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/job-credits/?${stringifiedParams}` : `/api/job-credits/`
}

/**
 * Deprecated — use /api/hire/job-credits/ instead. Behaviour is identical.
 *
 * ViewSet for JobCredit management - admin only.
 * @deprecated
 */
export const jobCreditsList = async (params?: JobCreditsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedJobCreditList> => {

  return customFetch<PaginatedJobCreditList>(getJobCreditsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getJobCreditsListInfiniteQueryKey = (params?: JobCreditsListParams,) => {
    return [
    'infinite', `/api/job-credits/`, ...(params ? [params] : [])
    ] as const;
    }

export const getJobCreditsListQueryKey = (params?: JobCreditsListParams,) => {
    return [
    `/api/job-credits/`, ...(params ? [params] : [])
    ] as const;
    }


export const getJobCreditsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof jobCreditsList>>, JobCreditsListParams['page']>, TError = void>(params?: JobCreditsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof jobCreditsList>>, TError, TData, QueryKey, JobCreditsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobCreditsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobCreditsList>>, QueryKey, JobCreditsListParams['page']> = ({ signal, pageParam }) => jobCreditsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof jobCreditsList>>, TError, TData, QueryKey, JobCreditsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type JobCreditsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof jobCreditsList>>>
export type JobCreditsListInfiniteQueryError = void


export function useJobCreditsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof jobCreditsList>>, JobCreditsListParams['page']>, TError = void>(
 params: undefined |  JobCreditsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof jobCreditsList>>, TError, TData, QueryKey, JobCreditsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCreditsList>>,
          TError,
          Awaited<ReturnType<typeof jobCreditsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCreditsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof jobCreditsList>>, JobCreditsListParams['page']>, TError = void>(
 params?: JobCreditsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof jobCreditsList>>, TError, TData, QueryKey, JobCreditsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCreditsList>>,
          TError,
          Awaited<ReturnType<typeof jobCreditsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCreditsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof jobCreditsList>>, JobCreditsListParams['page']>, TError = void>(
 params?: JobCreditsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof jobCreditsList>>, TError, TData, QueryKey, JobCreditsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useJobCreditsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof jobCreditsList>>, JobCreditsListParams['page']>, TError = void>(
 params?: JobCreditsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof jobCreditsList>>, TError, TData, QueryKey, JobCreditsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobCreditsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getJobCreditsListQueryOptions = <TData = Awaited<ReturnType<typeof jobCreditsList>>, TError = void>(params?: JobCreditsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCreditsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobCreditsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobCreditsList>>> = ({ signal }) => jobCreditsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof jobCreditsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type JobCreditsListQueryResult = NonNullable<Awaited<ReturnType<typeof jobCreditsList>>>
export type JobCreditsListQueryError = void


export function useJobCreditsList<TData = Awaited<ReturnType<typeof jobCreditsList>>, TError = void>(
 params: undefined |  JobCreditsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCreditsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCreditsList>>,
          TError,
          Awaited<ReturnType<typeof jobCreditsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCreditsList<TData = Awaited<ReturnType<typeof jobCreditsList>>, TError = void>(
 params?: JobCreditsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCreditsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCreditsList>>,
          TError,
          Awaited<ReturnType<typeof jobCreditsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCreditsList<TData = Awaited<ReturnType<typeof jobCreditsList>>, TError = void>(
 params?: JobCreditsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCreditsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useJobCreditsList<TData = Awaited<ReturnType<typeof jobCreditsList>>, TError = void>(
 params?: JobCreditsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCreditsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobCreditsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getJobCreditsCreateUrl = () => {




  return `/api/job-credits/`
}

/**
 * Deprecated — use /api/hire/job-credits/ instead. Behaviour is identical.
 *
 * ViewSet for JobCredit management - admin only.
 * @deprecated
 */
export const jobCreditsCreate = async (jobCreditCreateRequest?: JobCreditCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<JobCreditCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<JobCreditCreateResponse>(getJobCreditsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(jobCreditCreateRequest)
  }
);}





export const getJobCreditsCreateMutationKey = () => ['jobCreditsCreate'] as const;

export const getJobCreditsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobCreditsCreate>>, TError,JobCreditsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof jobCreditsCreate>>, TError,JobCreditsCreateMutationVariables, TContext> => {

const mutationKey = getJobCreditsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof jobCreditsCreate>>, JobCreditsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  jobCreditsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JobCreditsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof jobCreditsCreate>>>
    export type JobCreditsCreateMutationBody = JobCreditCreateRequest | undefined
    export type JobCreditsCreateMutationError = void
    export type JobCreditsCreateMutationVariables = {data?: JobCreditCreateRequest}

    /**
 * @deprecated
 */
export const useJobCreditsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobCreditsCreate>>, TError,JobCreditsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof jobCreditsCreate>>,
        TError,
        JobCreditsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getJobCreditsCreateMutationOptions(options), queryClient);
    }
    export const getJobCreditsRetrieveUrl = (id: number,) => {




  return `/api/job-credits/${id}/`
}

/**
 * Deprecated — use /api/hire/job-credits/ instead. Behaviour is identical.
 *
 * ViewSet for JobCredit management - admin only.
 * @deprecated
 */
export const jobCreditsRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<JobCredit> => {

  return customFetch<JobCredit>(getJobCreditsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getJobCreditsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/job-credits/${id}/`
    ] as const;
    }


export const getJobCreditsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof jobCreditsRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCreditsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobCreditsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobCreditsRetrieve>>> = ({ signal }) => jobCreditsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof jobCreditsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type JobCreditsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof jobCreditsRetrieve>>>
export type JobCreditsRetrieveQueryError = void


export function useJobCreditsRetrieve<TData = Awaited<ReturnType<typeof jobCreditsRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCreditsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCreditsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof jobCreditsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCreditsRetrieve<TData = Awaited<ReturnType<typeof jobCreditsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCreditsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCreditsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof jobCreditsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCreditsRetrieve<TData = Awaited<ReturnType<typeof jobCreditsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCreditsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useJobCreditsRetrieve<TData = Awaited<ReturnType<typeof jobCreditsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCreditsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobCreditsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getJobCreditsUpdateUrl = (id: number,) => {




  return `/api/job-credits/${id}/`
}

/**
 * Deprecated — use /api/hire/job-credits/ instead. Behaviour is identical.
 *
 * ViewSet for JobCredit management - admin only.
 * @deprecated
 */
export const jobCreditsUpdate = async (id: number,
    jobCreditRequest?: JobCreditRequest, options?: Parameters<typeof customFetch>[1]): Promise<JobCredit> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<JobCredit>(getJobCreditsUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(jobCreditRequest)
  }
);}





export const getJobCreditsUpdateMutationKey = () => ['jobCreditsUpdate'] as const;

export const getJobCreditsUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobCreditsUpdate>>, TError,JobCreditsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof jobCreditsUpdate>>, TError,JobCreditsUpdateMutationVariables, TContext> => {

const mutationKey = getJobCreditsUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof jobCreditsUpdate>>, JobCreditsUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  jobCreditsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JobCreditsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof jobCreditsUpdate>>>
    export type JobCreditsUpdateMutationBody = JobCreditRequest | undefined
    export type JobCreditsUpdateMutationError = void
    export type JobCreditsUpdateMutationVariables = {id: number;data?: JobCreditRequest}

    /**
 * @deprecated
 */
export const useJobCreditsUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobCreditsUpdate>>, TError,JobCreditsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof jobCreditsUpdate>>,
        TError,
        JobCreditsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getJobCreditsUpdateMutationOptions(options), queryClient);
    }
    export const getJobCreditsPartialUpdateUrl = (id: number,) => {




  return `/api/job-credits/${id}/`
}

/**
 * Deprecated — use /api/hire/job-credits/ instead. Behaviour is identical.
 *
 * ViewSet for JobCredit management - admin only.
 * @deprecated
 */
export const jobCreditsPartialUpdate = async (id: number,
    patchedJobCreditRequest?: PatchedJobCreditRequest, options?: Parameters<typeof customFetch>[1]): Promise<JobCredit> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<JobCredit>(getJobCreditsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedJobCreditRequest)
  }
);}





export const getJobCreditsPartialUpdateMutationKey = () => ['jobCreditsPartialUpdate'] as const;

export const getJobCreditsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobCreditsPartialUpdate>>, TError,JobCreditsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof jobCreditsPartialUpdate>>, TError,JobCreditsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getJobCreditsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof jobCreditsPartialUpdate>>, JobCreditsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  jobCreditsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JobCreditsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof jobCreditsPartialUpdate>>>
    export type JobCreditsPartialUpdateMutationBody = PatchedJobCreditRequest | undefined
    export type JobCreditsPartialUpdateMutationError = void
    export type JobCreditsPartialUpdateMutationVariables = {id: number;data?: PatchedJobCreditRequest}

    /**
 * @deprecated
 */
export const useJobCreditsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobCreditsPartialUpdate>>, TError,JobCreditsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof jobCreditsPartialUpdate>>,
        TError,
        JobCreditsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getJobCreditsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getJobCreditsStatsRetrieveUrl = () => {




  return `/api/job-credits/stats/`
}

/**
 * Deprecated — use /api/hire/job-credits/ instead. Behaviour is identical.
 *
 * Get credit statistics for the active location (X-Gigpro-Location-Id header).
 *
 * Per WORK-5057, stats follow the active location, not the org. The header is
 * required — the FE interceptor sends it on every request. The caller's
 * permission to read this location is verified before any DB aggregation runs.
 *
 * - available: Unused credits (used_ts is null)
 * - free_available: Unused free credits (used_ts is null and fee_cents=0)
 * - pending: Job offers with status=SENT at this location
 * - used: Credits with used_ts set and linked to ACCEPTED job offers
 * @deprecated
 */
export const jobCreditsStatsRetrieve = async ( options?: Parameters<typeof customFetch>[1]): Promise<JobCreditStats> => {

  return customFetch<JobCreditStats>(getJobCreditsStatsRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getJobCreditsStatsRetrieveQueryKey = () => {
    return [
    `/api/job-credits/stats/`
    ] as const;
    }


export const getJobCreditsStatsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof jobCreditsStatsRetrieve>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCreditsStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobCreditsStatsRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobCreditsStatsRetrieve>>> = ({ signal }) => jobCreditsStatsRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof jobCreditsStatsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type JobCreditsStatsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof jobCreditsStatsRetrieve>>>
export type JobCreditsStatsRetrieveQueryError = void


export function useJobCreditsStatsRetrieve<TData = Awaited<ReturnType<typeof jobCreditsStatsRetrieve>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCreditsStatsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCreditsStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof jobCreditsStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCreditsStatsRetrieve<TData = Awaited<ReturnType<typeof jobCreditsStatsRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCreditsStatsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCreditsStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof jobCreditsStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCreditsStatsRetrieve<TData = Awaited<ReturnType<typeof jobCreditsStatsRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCreditsStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useJobCreditsStatsRetrieve<TData = Awaited<ReturnType<typeof jobCreditsStatsRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCreditsStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobCreditsStatsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






